module.exports = __webpack_public_path__ + "static/media/side-effects-by-method-sprite@2x.5165b439.png";